/**
 * Circular flag asset for a currency code, shared by every surface that renders
 * a currency pill (the calculator, the rates strip, the comparison table's
 * payout selector).
 *
 * Most supported codes have a dedicated 96×96 crop under
 * `/images/calculator/`. The remaining supported codes use circular flag SVGs
 * from the homepage's supported-countries strip. Unknown runtime values resolve
 * to a safe static fallback rather than becoming part of an asset URL.
 */
const FLAG_SOURCES: Readonly<Record<string, string>> = {
  USD: '/images/calculator/USD.png',
  EUR: '/images/flags/eu.svg',
  GBP: '/images/flags/gb.svg',
  EGP: '/images/calculator/EGP.png',
  BDT: '/images/calculator/BDT.png',
  PKR: '/images/calculator/PKR.png',
  NGN: '/images/calculator/NGN.png',
  MAD: '/images/calculator/MAD.png',
  TRY: '/images/calculator/TRY.png',
  SYP: '/images/flags/sy.svg',
};

export function currencyFlagSrc(code: string): string {
  // Keep runtime text out of the URL. Currency codes can originate in a DOM
  // selector, so interpolating an unknown value here creates an unsafe
  // DOM-to-URL flow even though every current option is application-owned.
  return FLAG_SOURCES[code] ?? '/images/flags/us.svg';
}
